import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DocumentOperatorDashboardComponent } from '../document-operator-panel/document-operator-dashboard/document-operator-dashboard.component';

@Component({
  selector: 'app-document-operator-panel',
  templateUrl: './document-operator-panel.component.html',
  styleUrls: ['./document-operator-panel.component.css']
})

export class DocumentOperatorPanelComponent implements OnInit {

  @ViewChild("theDashboard") child: DocumentOperatorDashboardComponent;

  constructor(private route: ActivatedRoute) { }

  parameters: any;
  navigationInfoModule: string;
  navigationInfoFunction: string;
  navigationInfoClassPaddingLeft: string;

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(params => {
        this.parameters = {
          resourceNumber: params.resourceNumber,
          equipmentNumber: params.equipmentNumber,
          SessionId: params.SessionId,
        };
      }
    );
    this.navigationInfoClassPaddingLeft = "150px";
  }
}

